import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/permission'
import elDragDialog from './utils/el-drag-dialog/index'
import { getRem } from './utils'

import './assets/fonts/BebasNeue.css'
import './assets/fonts/PingFang.css'
import './assets/fonts/FZJinCTJW_Te.css'
import './assets/fonts/DIN.css'

Vue.config.productionTip = false

Vue.prototype.$store = store
Vue.prototype.$api = api

Vue.use(ElementUI)

Vue.directive('elDragDialog', elDragDialog)

document.addEventListener('DOMContentLoaded', () => {
  getRem()
})
window.addEventListener('resize', () => {
  getRem()

  // 小于850收起侧边栏
  var offsetWid = document.documentElement.clientWidth
  if (offsetWid <= 850) store.commit('app/setIsCollapse', true)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
